import PlatformService, { PlatformType } from 'services/platform';

interface Utm {
  campaign: string;
  source?: string;
  medium?: string;
  term?: string;
  content?: string | null;
}

interface Props extends Utm {
  link: string;
}

const addUtmTags = (props: Props) => {
  let term;

  switch (PlatformService.platform) {
    case PlatformType.WINDOWS:
    case PlatformType.WINDOWS32:
    case PlatformType.WINDOWS64:
      term = 'windows';
      break;
    case PlatformType.MACOS:
      term = 'macos';
      break;
    case PlatformType.LINUX:
      term = 'linux';
      break;
    case PlatformType.IOS:
      term = 'ios';
      break;
    case PlatformType.ANDROID:
      term = 'android';
      break;
    case PlatformType.WINDOWS_PHONE:
      term = 'windows-phone';
      break;
  }

  const {
    link,
    source = 'delta.app',
    medium = 'website',
    campaign,
    content = null,
  } = props;

  const prefix = link.indexOf('?') === -1 ? '?' : '&';
  const utm: Utm = {
    source,
    medium,
    campaign,
    term,
    content,
  };

  let trackingLink = `${link}${prefix}`;
  for (const [key, value] of Object.entries(utm)) {
    if (!value) {
      continue;
    }

    trackingLink += `utm_${key}=${encodeURIComponent(value)}&`;
  }

  return trackingLink.substr(0, trackingLink.length - 1);
};

export const addGenericTags = (link: string) =>
  addUtmTags({ link, campaign: 'delta' });

export const addDirectTags = (link: string) =>
  addUtmTags({ link, campaign: 'delta-direct' });
